import React, { useLayoutEffect, useState } from "react";
import Errors from "../../assets/images/404.jpg";
import "../../assets/css/error.css";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function Error() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useLayoutEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const height = windowDimensions.height;
  console.log(height);
  return (
    <div className="error" style={{ height: height }}>
      <img alt="err" src={Errors} />
    </div>
  );
}
